/* eslint-disable @typescript-eslint/no-unused-vars */
import { GraficoIngresosGeneral } from './ingreso_general';

export function Ingresos() {
    return <>
        <GraficoIngresosGeneral />
    </>
}